<template>
  <div class="planMap">
    <el-container style="height:100%;">
      <el-header style="height:160px; padding:0px;">
        <el-row>
          <el-form :model="form" ref="ruleForm" label-width="100px" class="planM-ruleForm">
            <el-form-item>
              <el-date-picker
                class="planM-time1"
                v-model="form.date1"
                type="datetime"
                placeholder="选择起始日期"
              ></el-date-picker>
              <el-date-picker
                class="planM-time1"
                v-model="form.date2"
                type="datetime"
                placeholder="选择截止日期"
              ></el-date-picker>
              <el-button class="planM-time2" type="primary" @click="submitForm('ruleForm')">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <el-col style="width: 14.18%;">
            <div class="planM-list" @click="orderFiltrate('1')">
              <div class="planM-list-box1">仓库总装箱量</div>
              <div class="planM-list-box2">40</div>
            </div>
          </el-col>
          <el-col style="width: 14.18%;">
            <div class="planM-list" @click="orderFiltrate('1')">
              <div class="planM-list-box1">总任务</div>
              <div class="planM-list-box2">{{quantityform.sum}}</div>
            </div>
          </el-col>
          <el-col style="width: 14.18%;">
            <div class="planM-list" @click="orderFiltrate('2')">
              <div class="planM-list-box1">待运输任务</div>
              <div class="planM-list-box2">{{quantityform.import}}</div>
            </div>
          </el-col>
          <el-col style="width: 14.18%;">
            <div class="planM-list" @click="orderFiltrate('3')">
              <div class="planM-list-box1">运输中任务</div>
              <div class="planM-list-box2">{{quantityform.transportation}}</div>
            </div>
          </el-col>
          <el-col style="width: 14.18%;">
            <div class="planM-list" @click="orderFiltrate('4')">
              <div class="planM-list-box1">已送到任务</div>
              <div class="planM-list-box2">{{quantityform.delivery}}</div>
            </div>
          </el-col>
          <el-col style="width: 14.18%;">
            <div class="planM-list3" @click="orderFiltrate('5')">
              <div class="planM-list-box1">经暂落场地</div>
              <div class="planM-list-box2">{{quantityform.neww}}</div>
            </div>
          </el-col>
          <el-col style="width: 14.18%;">
            <div class="planM-list2" @click="orderFiltrate('6')">
              <div class="planM-list-box1">直接上岛</div>
              <div class="planM-list-box2">{{quantityform.formerw}}</div>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-aside width="240px" style="padding:10px;">
          <div class="plan-aside-w3">
            <div class="plan-aside" v-for="(item,index) in plateData2">
              <div class="plan-aside-box">
                <div class="plan-aside-box1">{{item.start}}</div>
                <div class="plan-aside-box2">{{item.condition}}</div>
              </div>
              <div class="plan-aside-box3">参考单号：{{item.odd}}</div>
              <div class="plan-aside-box4">要求到货：{{dataFormat(item.item,'yyyy-MM-dd hh:mm')}}</div>
              <div class="plan-aside-box5">承运商： {{item.supplierName}}</div>
              <div class="plan-aside-box6">{{item.start}}> {{item.carriage}}</div>
            </div>
          </div>
        </el-aside>
        <el-main style="padding:10px 0;">
          <div style="height:100%; width: 100%">
            <div id="echarts" :style="{  height: '100%' }"></div>
          </div>
        </el-main>
        <el-aside width="260px" style="padding:10px;">
          <div>
            <div style="width: 240px;">
              <el-autocomplete
                popper-class="my-autocomplete"
                v-model="state"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                @select="handleSelect"
                class="planM-warehouse"
              >
                <i
                  class="el-icon-search el-input__icon planM-search"
                  slot="suffix"
                  @click="handleIconClick"
                ></i>
                <template slot-scope="{ item }">
                  <div class="name">{{ item.name }}</div>
                </template>
              </el-autocomplete>
            </div>
            <div class="plan-aside-w2">
              <div class="transdata1">
                <div id="detetion-box2">
                  <div id="detetion-con1">
                    <ul
                      v-for="(item,index) in plateData"
                      :key="index"
                      @click="planMcoordinate(item,index)"
                      :class="index == dian ? 'detetion-con1-ul':''"
                    >
                      <li class="plan-con1-box1">{{item.name}}</li>
                      <li class="plan-con1-box2">总任务:{{item.sumQuantity}}</li>
                      <li class="plan-con1-box2">待运输任务:{{item.importQuantity}}</li>
                    </ul>
                  </div>
                  <div id="detetion-con2"></div>
                </div>
              </div>
            </div>
          </div>
        </el-aside>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        date1: "",
        date2: ""
      },
      titshow: 999,
      dian: 999,
      plateData2: [],
      plateData: [],
      labe: { color: "#000", fontSize: "10px", border: "1px solid #000" },
      restaurants: [],
      state: "",
      characters: { 1: "总单量", 2: "旧模式" },
      showMapComponent: this.value,
      keyword: "",
      center: [121.827798546925, 30.894968624592],
      zoom: "13",
      mapStyle: {
        width: "100%",
        height: this.mapHeight + "px"
      },
      quantityform: {
        name: "",
        sum: 0,
        import: 0,
        transportation: 0,
        delivery: 0,
        neww: 0,
        formerw: 0
      },
      todayDetetion2: [],
      todayDetetion: [],
      points: []
    };
  },
  watch: {
    value: function(currentValue) {
      this.showMapComponent = currentValue;
      if (currentValue) {
        this.keyword = "";
      }
    }
  },

  mounted() {
    var date1 = new Date(new Date(new Date().toLocaleDateString()).getTime());
    var startTime =
      date1.getFullYear() +
      "-" +
      (date1.getMonth() + 1 < 10
        ? "0" + (date1.getMonth() + 1)
        : date1.getMonth() + 1) +
      "-" +
      (date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate()) +
      "T" +
      "00" +
      ":" +
      "00" +
      ":" +
      "00" +
      ".000Z";
    var date2 = new Date(new Date(new Date().toLocaleDateString()).getTime());
    var endTime =
      date2.getFullYear() +
      "-" +
      (date2.getMonth() + 1 < 10
        ? "0" + (date2.getMonth() + 1)
        : date2.getMonth() + 1) +
      "-" +
      (date2.getDate() + 1 < 10
        ? "0" + (date2.getDate() + 1)
        : date2.getDate() + 1) +
      "T" +
      "00" +
      ":" +
      "00" +
      ":" +
      "00" +
      ".000Z";
    this.form.date1 = startTime;
    this.form.date2 = endTime;
    this.Bearer();
    // this.plateData = this.todayDetetion;
    // this.plateData2 = this.todayDetetion2;
    // this.ScrollUp2();
    this.planMap();
    this.hanss();
    this.restaurants = this.loadAll();
  },
  methods: {
    submitForm(e) {
      this.Bearer();
    },
    async Bearer() {
      var self = this;
      let data = {};
      data.fromTime = this.form.date1;
      data.toTime = this.form.date2;
      data.bizKey = [];
      let response = await this.apiService
        .post("/sinoslog-ops-service/sailingDate/queryTMSOrder", data)
        .then(res => {
          if (res.data.data.code == 0) {
            this.quantityform.sum = res.data.data.totalJob;
            this.quantityform.import = res.data.data.waitOfNumber;
            this.quantityform.transportation = res.data.data.ingOfNumber;
            this.quantityform.delivery = res.data.data.endOfNumber;
            this.quantityform.neww = res.data.data.ssgofNumber;
            this.quantityform.formerw = res.data.data.hxofNumber;
            let item1 = res.data.data.jobs;
            let item2 = res.data.data.transitStatusAddresses;
            let ww = res.data.data.pointNames;
            let list = [];
            for (var key in ww) {
              let wws = {};
              wws.nam = key;
              wws.sum = ww[key];
              list.push(wws);
            }
            for (let i in item1) {
              let arr = {};
              for (let j in item1[i].points) {
                if (item1[i].points[j].sequence == 1) {
                  arr.start = item1[i].points[j].address;
                } else if (item1[i].points[j].sequence == 2) {
                  arr.carriage = item1[i].points[j].address;
                  arr.item = item1[i].points[j].estimatedDate;
                }
              }
              arr.odd = item1[i].customerReferenceNo1;
              arr.supplierName = item1[i].supplierName;
              console.log(item1[i].transitStatus);
              if (item1[i].transitStatus == "DRAFTED") {
                arr.condition = "未派单";
              } else if (item1[i].transitStatus == "ACCEPTED") {
                arr.condition = "接单";
              } else if (item1[i].transitStatus == "PLANNED") {
                arr.condition = "已派车";
              } else if (item1[i].transitStatus == "IN_TRANSIT") {
                arr.condition = "运输中";
              } else if (item1[i].transitStatus == "DELIVERY") {
                arr.condition = "已签收";
              } else if (item1[i].transitStatus == "RECEIPT_SIGNED") {
                arr.condition = "接单";
              } else {
                arr.condition = "已派单";
              }
              self.todayDetetion2.push(arr);
            }
            this.plateData2 = this.todayDetetion2;
            for (let k in item2) {
              let arr2 = {};
              if (item2[k].address == "洋山码头") {
                for (let y in list) {
                  console.log(list[y].sum);
                  if (list[y].nam == "洋山码头") {
                    arr2.sumQuantity = list[y].sum;
                  }
                }
                arr2.name = item2[k].address;
                arr2.importQuantity = item2[k].transitStatusWait;
                arr2.transportationQuantity = item2[k].transitStatusIng;
                arr2.deliveryQuantity = item2[k].transitStatusEnd;
                arr2.center = [122.02341546032713, 30.659771463727053];
              } else if (item2[k].address == "普捷通堆场") {
                for (let y in list) {
                  if (list[y].nam == "普捷通堆场") {
                    arr2.sumQuantity = list[y].sum;
                  }
                }
                arr2.name = item2[k].address;
                arr2.importQuantity = item2[k].transitStatusWait;
                arr2.transportationQuantity = item2[k].transitStatusIng;
                arr2.deliveryQuantity = item2[k].transitStatusEnd;
                arr2.center = [121.873112224399, 30.8889090581464];
              } else if (item2[k].address == "华迅仓库") {
                for (let y in list) {
                  if (list[y].nam == "华迅仓库") {
                    arr2.sumQuantity = list[y].sum;
                  }
                }
                arr2.name = item2[k].address;
                arr2.importQuantity = item2[k].transitStatusWait;
                arr2.transportationQuantity = item2[k].transitStatusIng;
                arr2.deliveryQuantity = item2[k].transitStatusEnd;
                arr2.center = [121.877698446825, 30.894968624592];
              } else if (item2[k].address == "深水港") {
                for (let y in list) {
                  if (list[y].nam == "深水港") {
                    arr2.sumQuantity = list[y].sum;
                  }
                }
                arr2.name = item2[k].address;
                arr2.importQuantity = item2[k].transitStatusWait;
                arr2.transportationQuantity = item2[k].transitStatusIng;
                arr2.deliveryQuantity = item2[k].transitStatusEnd;
                arr2.center = [122.02341546032713, 30.659771463727053];
              }
              self.todayDetetion.push(arr2);
            }
            this.plateData = self.todayDetetion;
            this.planMap();
          }
        });
    },
    planMap() {
      var echarts = require("echarts/lib/echarts");
      require("echarts/lib/chart/line");
      require("echarts/lib/component/title");
      var myChart = echarts.init(document.getElementById("echarts"));
      var data = this.todayDetetion;
      // [
      //   { name: "普捷通堆场", value: 3 },
      //   { name: "华迅仓库", value: 120 },
      //   { name: "深水港", value: 40 },
      //   { name: "洋山码头", value: 6 },
      //   { name: "上海陆大洲物流有限公司", value: 1 },
      //   { name: "神州仓储股份有限公司", value: 0 },
      //   { name: "上海力丰物流有限公司", value: 0 },
      //   { name: "天恒国际物流有限公司", value: 0 },
      //   { name: "上海森博国际物流有限公司", value: 0 },
      //   { name: "上海宜欧国际物流有限公司", value: 0 },
      //   { name: "上海天宏集装箱储运有限公司", value: 0 },
      //   { name: "上海博晨国际货物运输代理有限公司", value: 0 }
      // ];
      var geoCoordMap = {
        普捷通堆场: [121.873112224399, 30.8889090581464],
        华迅仓库: [121.877698446825, 30.894968624592],
        深水港: [121.890169316796, 30.8833505166133],
        洋山码头: [122.02341546032713, 30.659771463727053],
        上海陆大洲物流有限公司: [121.76820577135, 30.9056504739804],
        神州仓储股份有限公司: [121.875088983403, 30.8913808810217],
        上海力丰物流有限公司: [121.832689981112, 30.8752078646022],
        天恒国际物流有限公司: [121.850031332406, 30.874865059491],
        上海森博国际物流有限公司: [121.856681471028, 30.9885304924164],
        上海宜欧国际物流有限公司: [121.897591027089, 30.8698251234982],
        上海天宏集装箱储运有限公司: [121.753161655839, 30.9046260182283],
        上海博晨国际货物运输代理有限公司: [121.873715773414, 30.8861403268306]
      };

      var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].sumQuantity)
            });
          }
        }
        return res;
      };
      let option = {
        title: {
          text: "地图",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          show: false
        },
        bmap: {
          center: this.center,
          zoom: this.zoom,
          roam: true,
          mapStyle: {
            styleJson: [
              {
                featureType: "water",
                elementType: "all",
                stylers: {
                  color: "#d1d1d1"
                }
              },
              {
                featureType: "land",
                elementType: "all",
                stylers: {
                  color: "#f3f3f3"
                }
              },
              {
                featureType: "railway",
                elementType: "all",
                stylers: {
                  visibility: "off"
                }
              },
              {
                featureType: "highway",
                elementType: "all",
                stylers: {
                  color: "#fdfdfd"
                }
              },
              {
                featureType: "highway",
                elementType: "labels",
                stylers: {
                  visibility: "off"
                }
              },
              {
                featureType: "arterial",
                elementType: "geometry",
                stylers: {
                  color: "#fefefe"
                }
              },
              {
                featureType: "arterial",
                elementType: "geometry.fill",
                stylers: {
                  color: "#fefefe"
                }
              },
              {
                featureType: "poi",
                elementType: "all",
                stylers: {
                  visibility: "off"
                }
              },
              {
                featureType: "green",
                elementType: "all",
                stylers: {
                  visibility: "off"
                }
              },
              {
                featureType: "subway",
                elementType: "all",
                stylers: {
                  visibility: "off"
                }
              },
              {
                featureType: "manmade",
                elementType: "all",
                stylers: {
                  color: "#d1d1d1"
                }
              },
              {
                featureType: "local",
                elementType: "all",
                stylers: {
                  color: "#d1d1d1"
                }
              },
              {
                featureType: "arterial",
                elementType: "labels",
                stylers: {
                  visibility: "off"
                }
              },
              {
                featureType: "boundary",
                elementType: "all",
                stylers: {
                  color: "#fefefe"
                }
              },
              {
                featureType: "building",
                elementType: "all",
                stylers: {
                  color: "#d1d1d1"
                }
              },
              {
                featureType: "label",
                elementType: "labels.text.fill",
                stylers: {
                  color: "#999999"
                }
              }
            ]
          }
        },
        series: [
          {
            type: "scatter",
            coordinateSystem: "bmap",
            data: convertData(data),
            symbolSize: function(val) {
              return val[2] / 10;
            },
            encode: {
              value: 2
            },
            label: {
              formatter: "{ b }".value,
              show: false
            },
            itemStyle: {
              color: "purple"
            },
            emphasis: {
              label: {
                show: true
              }
            }
          },
          {
            type: "effectScatter",
            coordinateSystem: "bmap",
            data: convertData(
              data
                .sort(function(a, b) {
                  return b.value - a.value;
                })
                .slice(0, 6)
            ),
            symbolSize: function(val) {
              if (val[2] < 20) {
                return 15;
              } else if (val[2] > 100) {
                return 25;
              } else {
                return 21;
              }
            },
            encode: {
              value: 2
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            hoverAnimation: true,
            label: {
              formatter: "{ b }".value,
              color: "#fff",
              offset: [0, 1],
              show: true
            },
            itemStyle: {
              color: "#008cff",
              shadowBlur: 10,
              shadowColor: "#008cff"
            },
            zlevel: 1
          }
        ]
      };
      myChart.setOption(option);
      //点击事件,根据点击某个省份计算出这个省份的数据
      let that = this;
      myChart.on("click", function(params) {
        that.planMclick(params.data.name);
        //逻辑控制
      });
    },
    planMclick(e) {
      let tt = {};
      for (let i in this.todayDetetion) {
        if (this.todayDetetion[i].name == e) {
          tt = this.todayDetetion[i];
        }
      }
      this.handleSelect(tt);
      this.planMcoordinate(tt);
    },
    // planMclick(e) {
    //   this.handleSelect(e);
    //   this.planMcoordinate(e, 0);
    // },
    // enters(index) {
    //   this.titshow = index;
    // },
    // leaver(index) {
    //   this.titshow = 999;
    // },

    hanss() {
      if (this.todayDetetion.length > 0) {
        for (let i in this.todayDetetion) {
          this.quantityform.sum += +this.todayDetetion[i].sumQuantity;
          this.quantityform.import += +this.todayDetetion[i].importQuantity;
          this.quantityform.transportation += +this.todayDetetion[i]
            .transportationQuantity;
          this.quantityform.delivery += +this.todayDetetion[i].deliveryQuantity;
        }
      }
    },
    handleIconClick() {
      if (!this.state1) {
        this.plateData = this.todayDetetion;
        this.quantityform.sum = 0;
        this.quantityform.import = 0;
        this.quantityform.transportation = 0;
        this.quantityform.delivery = 0;
        this.hanss();
        this.plateData2 = this.todayDetetion2;
      }
    },
    orderFiltrate(e) {
      this.plateData2 = [];
      if (e !== "1") {
        for (let i in this.todayDetetion2) {
          if (this.todayDetetion2[i].condition == "已派单" && e == "2") {
            if (this.todayDetetion2[i].start == this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            } else if (!this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            }
          } else if (this.todayDetetion2[i].condition == "运输中" && e == "3") {
            if (this.todayDetetion2[i].start == this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            } else if (!this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            }
          } else if (this.todayDetetion2[i].condition == "已送达" && e == "4") {
            if (this.todayDetetion2[i].start == this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            } else if (!this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            }
          } else if (this.todayDetetion2[i].pattern == "新" && e == "5") {
            if (this.todayDetetion2[i].start == this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            } else if (!this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            }
          } else if (this.todayDetetion2[i].pattern == "旧" && e == "6") {
            if (this.todayDetetion2[i].start == this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            } else if (!this.quantityform.name) {
              this.plateData2.push(this.todayDetetion2[i]);
            }
          }
        }
      } else {
        for (let i in this.todayDetetion2) {
          if (this.todayDetetion2[i].start == this.quantityform.name) {
            this.plateData2.push(this.todayDetetion2[i]);
          } else if (!this.quantityform.name) {
            this.plateData2 = this.todayDetetion2;
          }
        }
      }
    },
    // 计算
    planMcoordinate(e, index) {
      this.dian = index;
      this.plateData2 = [];
      this.center = e.center;
      this.quantityform.name = e.name;
      this.quantityform.sum = e.sumQuantity;
      this.quantityform.import = e.importQuantity;
      this.quantityform.transportation = e.transportationQuantity;
      this.quantityform.delivery = e.deliveryQuantity;
      this.zoom = 18;
      for (let i in this.todayDetetion2) {
        if (e.name == this.todayDetetion2[i].start) {
          this.plateData2.push(this.todayDetetion2[i]);
        }
      }
      this.planMap();
    },
    /***
     * 地图点击事件。
     */
    // getClickInfo(e) {
    //   this.center.lng = e.point.lng;
    //   this.center.lat = e.point.lat;
    // },
    // syncCenterAndZoom(e) {
    //   this.center = e;
    //   this.center.lat = e.lat;
    //   this.zoom = 18;
    // },

    // 无限滚动
    // getData() {
    //   var _this = this;
    //   this.$axios
    //     .get("请求的url")
    //     .then(res => {
    //       this.todayDetetion2 = res.data.data;
    //       this.$nextTick(() => {});
    //     })
    //     .catch(err => {});
    // },
    ScrollUp2() {
      var box = document.getElementById("detetion-box2");
      var con1 = document.getElementById("detetion-con1");
      var con2 = document.getElementById("detetion-con2");
      this.speed = 50;
      if (con1.offsetHeight >= box.offsetHeight) {
        con2.innerHTML = con1.innerHTML;
        var timer1 = setInterval(scrol, this.speed);
        function scrol() {
          /*判断滚动内容是否已经滚完，滚完了则滚动的值重新设置到0，否则就每个30默秒向上滚动1px */
          if (box.scrollTop >= con1.scrollHeight) {
            box.scrollTop = 0;
          } else {
            box.scrollTop++;
          }
          /*判断滚动的距离刚好为一条公告的高度时停掉定时器，隔1s之后重新启动计时器即可实现公告滚动停留效果 */
          if (box.scrollTop % 80 == 0) {
            clearInterval(timer1);
            setTimeout(() => {
              timer1 = setInterval(scrol, 30);
            }, 2000);
          }
        }
      }
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    loadAll() {
      return this.todayDetetion;
    },
    handleSelect(item) {
      this.state = item.name;
      if (item.name == "") {
        this.plateData = this.todayDetetion;
      } else {
        this.plateData = [];
        for (let i in this.todayDetetion) {
          if (item.name == this.todayDetetion[i].name) {
            this.plateData.push(this.todayDetetion[i]);
          }
        }
      }
    },
    /**
     * 格式化日期,特殊定制化的格式化
     **/
    dataFormat(date, format) {
      // 兼容IE
      var time;
      if (!date) return "";
      if (typeof date === "string") {
        time = new Date(
          date
            .replace(/-/g, "/")
            .replace(/T|Z/g, " ")
            .trim()
        );
      } else if (typeof date === "object") {
        time = new Date(date);
      }
      var o = {
        "M+": time.getMonth() + 1, //月份
        "d+": time.getDate(), //日
        "h+": time.getHours(), //小时
        "m+": time.getMinutes(), //分
        "s+": time.getSeconds(), //秒
        "q+": Math.floor((time.getMonth() + 3) / 3), //季度
        S: time.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(format))
        format = format.replace(
          RegExp.$1,
          (time.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(format))
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return format;
    }
  }
};
</script>

<style>
ul,
li {
  padding-left: 0;
}
.planMap {
  height: 100%;
  /* background-color: #111f44; */
  background-color: #fff;
}
.serachinput {
  width: 300px;
  box-sizing: border-box;
  padding: 9px;
  border: 1px solid #dddee1;
  line-height: 20px;
  font-size: 16px;
  height: 38px;
  color: #333;
  position: relative;
  border-radius: 4px;
  -webkit-box-shadow: #666 0px 0px 10px;
  -moz-box-shadow: #666 0px 0px 10px;
  box-shadow: #666 0px 0px 10px;
}
.bm-view {
  height: 100%;
}
/* 55 */
.planM-entrepot {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}

.transdata1 {
  /* height: 100%; */
  box-sizing: border-box;
  transform: translateY(-12px);
}
.tody-table-header2 {
  overflow: hidden;
}

.tody-table-header2 li {
  height: 24px;
  width: 82px;
  line-height: 24px;
  list-style: none;
  float: left;
  font-size: 13px;
  margin-right: 48px;
  font-family: MicrosoftYaHei;
  color: rgba(127, 250, 255, 1);
  text-align: center;
  background-size: 100% 100%;
}
.tody-table-header2 li:last-child {
  margin-right: 0;
}
#detetion-box2 {
  margin-top: 13px;
  height: 100%;
  overflow: hidden;
}
#detetion-box2 ul {
  overflow: hidden;
  border-bottom: 2px solid #ccc;
}
#detetion-box2 li {
  line-height: 22px;
  margin-right: 10px;
  font-size: 12px;
  color: #000;
  text-align: left;
}
#detetion-box2 ul li:last-child {
  margin-right: 0;
}
#detetion-con1 > ul {
  /* padding-left: 0 !important; */
  padding-top: 10px;
  margin: 0px 0;
}
.detetion-con1-ul {
  background-color: #ecf5ff;
}

.plan-aside-w2 {
  width: 240px;
  position: fixed;
  top: 200px;
  bottom: 0;
  right: 10px;
  overflow-y: auto;
}
/* 订单 */
.planM-list {
  background-color: #4072b8;
  height: 100px;
  margin: 2px 2px;
  display: flex;
  line-height: 100px;
}

.planM-list2 {
  background-color: red;
  height: 100px;
  margin: 2px 2px;
  display: flex;
  line-height: 100px;
}
.planM-list3 {
  background-color: green;
  height: 100px;
  margin: 2px 2px;
  display: flex;
  line-height: 100px;
}

.planM-list-box1 {
  flex: 1;
  color: #fff;
  font-size: 18px;
}
.planM-list-box2 {
  flex: 1;
  color: #fff;
  font-size: 26px;
}
.plan-con1-box1 {
  text-align: left;
  font-weight: 700 !important;
  font-size: 14px !important;
}
.plan-con1-box2 {
  text-align: left;
  font-size: 13px !important;
}
.plan-con1-box3 {
  text-align: left;
  font-size: 13px !important;
}
/* 订单左边 */
.plan-aside-w3 {
  width: 220px;
  position: fixed;
  top: 170px;
  bottom: 0;
  left: 10px;
  overflow-y: auto;
}
.plan-aside {
  border-bottom: 2px solid #ccc;
}
.plan-aside-box {
  display: flex;
}
.plan-aside-box1 {
  flex: 1;
  text-align: left;
  font-weight: 700;
  font-size: 16px;
}
.plan-aside-box2 {
  flex: 1;
  text-align: right;
  color: #ccc;
}
.plan-aside-box3 {
  text-align: left;
  font-weight: 700;
  font-size: 14px;
}
.plan-aside-box4 {
  text-align: left;
  font-weight: 700;
  font-size: 14px;
}
.plan-aside-box5 {
  text-align: left;
  font-size: 15px;
  font-weight: 700;
}
.plan-aside-box6 {
  text-align: left;
  font-size: 14px;
  font-weight: 700;
  color: rgb(141, 141, 141);
}

.planM-warehouse > .el-input > .el-input__inner {
  height: 30px;
}
.planM-search {
  line-height: 30px;
}
.planM-ruleForm > .el-form-item {
  margin: 10px 0 10px 0 !important;
}
.planM-ruleForm > .el-form-item > .el-form-item__content {
  margin: 0 !important;
}
.planM-ruleForm {
  width: 520px;
}
</style>


// WEBPACK FOOTER //
// src/views/table/planMap.vue